/*=========================================================================================
  File Name: moduleCalendarState.js
  Description: Calendar Module State
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
  users:[],
  redeems:[],
  spin:[],
  roulet:[],
  admin:[],
  deposit:[],
  withdraw:[],
  setcredit:[],
  register:[],
  line:[],
}
